export function getdata() {
	let obj = {
		searchlist: [{
				prop: "templateName",
				label: '模板名称',
				type: "input"
			},
			{
				prop: "reportName",
				label: '报表',
				type: "input"
			},
			{
				prop: "shuizId",
				label: '税种',
				type: "select"
			},
			{
				prop: "isDefault",
				label: '是否默认',
				type: "select",
				selectval: [{
						label: "是",
						value: "1"
					},
					{
						label: "否",
						value: "0"
					}
				]
			},
			{
				prop: "versionShuom",
				label: '说明',
				type: "input"
			},
			{
				prop: "version",
				label: '版本名',
				type: "input"
			},
			{
				prop: "queryTime",
				label: '版本启用期间',
				type: "date",
			},
			{
				prop: "companyNames",
				label: '相关公司',
				type: "input",
			},
		],
		searchdata: {
			templateName: "",
			reportName: "",
			shuizId: "",
			isDefault: "",
			versionShuom: "",
			version: "",
			queryTime: [],
			companyNames: ""
		},
		headData: [{
				title: "模板名称",
				prop: "templateName",
				custom: true,
				width: 160,
			},
			{
				title: "税种",
				prop: "szName",
				custom: true,
				width: "80",
			},
			{
				title: "报表",
				prop: "reportName",
				custom: true,
				width: 160,
				
			},
			{
				title: "是否默认",
				prop: "isDefault",
				width: "80",
				custom: true
			},
			{
				title: "说明",
				prop: "versionShuom",
				width: 130,
				custom: true,
				
			},
			{
				title: "版本号",
				width: "80",
				custom: true,
				prop: "version",
			},
			{
				title: "版本启用期间",
				prop: "queryTime",
				custom: true,
				width: 130,
				
			},
			{
				title: "相关公司",
				prop: "companyNames",
				width: 160,
				custom: true,
			},
			{
				title: "操作",
				prop: "cz",
				width: "200",
				fixed: "right",
				custom: true
			},
		],
		headDatacompany: [{
				title: "公司代码",
				prop: "companyCode",
			},
			{
				title: "公司名称",
				prop: "nsrmc",
			},
		],
		headDatachoose: [{
				title: "公司代码",
				prop: "companyCode",
			},
			{
				title: "公司名称",
				prop: "nsrmc",
			},
		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
		paginationcompany: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},

	}
	return obj
}
